import WaterLevelTile from './WaterLevelTile.vue';
import FuelLevelTile from './FuelLevelTile.vue';
import GrayWaterLevelTile from './GrayWaterLevelTile.vue';
import BlackWaterLevelTile from './BlackWaterLevelTile.vue';
import LiveWellLevelTile from './LiveWellLevelTile.vue';
import OilLevelTile from './OilLevelTile.vue';
const FluidTileComponents = {
    WaterLevelTile,
    FuelLevelTile,
    GrayWaterLevelTile,
    LiveWellLevelTile,
    BlackWaterLevelTile,
    OilLevelTile,
};
export default FluidTileComponents;
